import { useEquipmentStore } from "@/frontend/store/EquipmentStore";
import { I18n } from "@/i18n/I18n";
import { capitalize } from "lodash";
import { useShallow } from "zustand/react/shallow";
import { ConfigurationCell } from "../equipment/ConfigurationCell";
import { EquipmentConnection } from "../equipment/EquipmentConnection";
import { LoadingSpinner } from "../LoadingSpinner";
import { Operation } from "@/backend/models/operation";

export function EquipmentOperationRun(props: { operation: Operation }) {
  const { operation } = props;
  const equipment = useEquipmentStore(useShallow(state => state.equipmentList)).find(({ id }) => id === operation.equipmentId);
  const loadingEquipmentList = useEquipmentStore(state => state.loadingEquipmentList);

  if (!equipment) {
    return null;
  }

  if (loadingEquipmentList) {
    return (
      <div className="card mb-3">
        <div className="card-body text-center">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  return (
    <div className="card mb-3">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h6 className="mb-0">
          {equipment.name}
        </h6>
      </div>
      <div className="card-body">
        <EquipmentConnection equipment={equipment} />
        { equipment.description && (
          <div className="mb-3">
            <strong>{I18n.get('description')}:</strong>
            <p className="mb-0 text-wrap text-break">{equipment.description}</p>
          </div>
        )}
        <strong>{capitalize(I18n.get('configuration'))}:</strong>
        <div className="mt-1">
          <ConfigurationCell item={equipment} />
        </div>
      </div>
    </div>
  );
}
